// import log from 'loglevel'
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const DEAUTHENTICATE_USER = 'DEAUTHENTICATE_USER';
export const ERROR = 'ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

const defaultState = {
    accessToken: '',
    authenticated: false,
  };

/**
 * Authentication reducer
 * @param  {Object} [state=defaultState] the previous state
 * @param  {Object} action               the action to apply••••••••
 * @return {Object}                      the new state
 */
export default function (state = defaultState, action) {
  switch (action.type) {
    case AUTHENTICATE_USER:
      return {
        ...state,
        errors: null,
        authenticated: true,
        accessToken: action.token,
        user: action.user,
      };
    case DEAUTHENTICATE_USER:
      // log.debug("In DEAUTHENTICATE")
      return {
        ...state,
        errors: null,
        authenticated: false,
        accessToken: '',
        //TODO: Check if to really delete User
        user: {},
      };
    //@FIXME use general implementation of Application package
    case ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          ...{
            param: action.param,
            message: action.message,
          }
        },
      };
    case CLEAR_ERROR:
      return {
        ...state,
        errors: null,
      };
    default:
      return state;
  }
}
